import React from 'react';
import Link from "next/link";
import classNames from "classnames";

function Menu(props) {
	return (
		<>
			<div className="menu md:w-1/4">
				<div className="settings-controls os-tabs-controls mb-4">
					<ul className="nav nav-pills upper sm:mr-5 flex flex-wrap sm:block">
						<li className="nav-item">
							<Link href="/settings" legacyBehavior>
								<a className={classNames(
									'tab-item',
									{'tab-selected': props.page == 'general'}
								)}>General</a>
							</Link>
						</li>
						
						<li className="nav-item">
							<Link href="/settings/password" legacyBehavior>
								<a className={classNames(
									'tab-item',
									{'tab-selected': props.page == 'password'}
								)}>Password</a>
							</Link>
						</li>
						
						<li className="nav-item">
							<Link href="/settings/notifications" legacyBehavior>
								<a className={classNames(
									'tab-item',
									{'tab-selected': props.page == 'notifications'}
								)}>Notifications</a>
							</Link>
						</li>
						
						<li className="nav-item">
							<Link href={process.env.NEXT_PUBLIC_ORIGINAL_URL + '/settings/billing'} legacyBehavior>
								<a className={classNames(
									'tab-item',
									{'tab-selected': props.page == 'billing'}
								)}>Billing</a>
							</Link>
						</li>
						
						<li className="nav-item">
							<Link href="/settings/social" legacyBehavior>
								<a className={classNames(
									'tab-item',
									{'tab-selected': props.page == 'social'}
								)}>Social Connections</a>
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
}

export default Menu;
